

import initmixin from "@/Services/initmixin";

export default {
 
  //mixins: [initmixin],
 // GET_CLIENTES CREAR_CLIENTES EDITAR_CLIENTES ELIMINAR_CLIENTES

 GET: async function( data){
      let url='/configuraciones/'
      return initmixin.formatrespuesta('get', data,url,true)
    },
    CREAR: async function( data) {
      let url='/configuraciones/'
      return initmixin.formatrespuesta('post',  data.data,url,true)
    },
    EDITAR: async function( data) {
      let url='/configuraciones/'+data.id
      return initmixin.formatrespuesta('post',  data.data,url,true,true)
    },
    ELIMINAR: async function( data) {
      let url='/configuraciones/'+data.id
      return initmixin.formatrespuesta('delete', data,url,true)
    },
   


}